import styled from 'styled-components'
import { BoxFill, BoxFullFill, Text } from 'styles'

interface IBlock {
  width?: number
  minWidth?: number
  maxWidth?: number
  noMargin?: boolean
}

export const Wrap = styled(BoxFill).attrs({
  spaceBetween: true,
})``

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const Block = styled.div<IBlock>`
  width: ${props => (props.width ? `${props.width}px` : '100%')};
  min-width: ${props => `${props.minWidth}px`};
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}px` : '100%')};
  height: 50px;
  margin: 0 5px;
  &:nth-child(1) {
    margin: 0 5px 0 0;
  }
`

export const ButtonBlock = styled.div`
  width: 138px;
  height: 50px;
  padding: 5px 0 0 0;
  margin: 0 0 0 5px;
`

export const SaveWrap = styled(BoxFill).attrs({
  spaceBetween: true,
  margin: '10px 0 0 0',
  padding: '0 20px 0 0',
})``

export const SavedSearches = styled.div`
  color: ${props => props.theme.main.colors.primary};
  position: relative;
  span {
    cursor: pointer;
    text-decoration-line: underline;
    &:hover {
      opacity: 0.8;
    }
  }
`

export const SavedThisSearch = styled(Text)`
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`

export const ContainerCard = styled(BoxFullFill).attrs({
  height: 'auto !important',
})<IBlock>`
  padding: 30px 0 0 0;
  display: grid;
  justify-content: stretch;
  grid-gap: 30px;
  width: 100%;
  height: auto !important;
  div {
    margin-top: ${props => (props.noMargin ? 0 : '30px')};
  }
`

export const SearchCount = styled(Text).attrs({})`
  margin: 10px 0 -20px 0;
`
